import * as React from "react";
import {
  eFilter,
  Filter,
  ISelectData,
  SortType,
  Typography
} from "front-end-lib/core";
import { classConstants, activeStatuses } from "../../constants";
import { IFilter } from "../../model";
import { MddStatus } from "../../components";

const sortRuleStatus = (a: { isActive: boolean }, b: { isActive: boolean }) =>
  a.isActive > b.isActive ? -1 : a.isActive === b.isActive ? 0 : 1;

const sortTriggerCourse = (
  a: { trigger: [string, string] },
  b: { trigger: [string, string] }
) => {
  const [taC = "", taLP = ""] = a.trigger;
  const [tbC = "", tbLP = ""] = b.trigger;
  const valueA = `${taC} ${taLP}`.toLowerCase();
  const valueB = `${tbC} ${tbLP}`.toLowerCase();
  return valueA > valueB ? 1 : valueA === valueB ? 0 : -1;
};

export const assignmentRulesDataTableHeaders = (
  filterOnChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    exactMatch?: boolean
  ) => void,
  typeOptions: ISelectData[],
  filterVals: Map<string, IFilter>
) => [
  {
    key: "RuleName",
    label: "Rule Name",
    sortProp: { sortPropName: "ruleName", desc: false },
    filter: new Filter(eFilter.Text, {
      debounceInterval: 0,
      textProps: {
        className: classConstants.TEXT_FILTER_CLASS,
        id: "ruleNameFilter",
        onChange: e => filterOnChange(e),
        name: "ruleName"
      }
    }),
    tableCellProps: { id: "ruleNameHeader" },
    divProps: { id: "ruleNameHeader_div" }
  },
  {
    key: "Type",
    label: "Type",
    sortProp: { sortPropName: "type", desc: false },
    filter: new Filter(eFilter.Select, {
      textProps: {
        debounceInterval: 0,
        id: "typeFilterText",
        name: "type",
        className: "tbl--filter-select",
        onChange: e => filterOnChange(e, true),
        InputLabelProps: { shrink: filterVals.has("type") }
      },
      selectMenuProps: { MenuProps: { className: "bracket-Select" } },
      menuProps: {},
      selectData: typeOptions,
      defaultSelect: true
    }),
    tableCellProps: { id: "typeHeader", className: "tbl--header-cell" },
    divProps: { id: "typeHeader_div" }
  },
  {
    key: "Trigger",
    label: "Trigger",
    sortProp: {
      sortPropName: "trigger",
      desc: false,
      sortType: "Custom" as SortType,
      alg: sortTriggerCourse
    },
    filter: new Filter(eFilter.Text, {
      debounceInterval: 0,
      textProps: {
        className: classConstants.TEXT_FILTER_CLASS,
        id: "triggerFilter",
        onChange: e => filterOnChange(e),
        name: "trigger"
      }
    }),
    formatProp: {
      formatPropName: "trigger",
      format: ([course, lp]: [string, string]) => (
        <div className="trigger-cell">
          <p title={course}>{course}</p>
          <Typography variant="caption" title={lp}>
            {lp}
          </Typography>
        </div>
      )
    },
    tableCellProps: { id: "triggerHeader" },
    divProps: { id: "triggerHeader_div" }
  },
  {
    key: "LearningPlanName",
    label: "Assigns Learning Plan",
    sortProp: { sortPropName: "assignLearningPlan", desc: false },
    filter: new Filter(eFilter.Text, {
      debounceInterval: 0,
      textProps: {
        className: classConstants.TEXT_FILTER_CLASS,
        id: "learningPlanNameFilter",
        onChange: e => filterOnChange(e),
        name: "assignLearningPlan"
      }
    }),
    tableCellProps: { id: "learningPlanNameHeader" },
    divProps: { id: "learningPlanNameHeader_div" }
  },
  {
    key: "Status",
    label: "Status",
    sortProp: {
      sortPropName: "isActive",
      desc: false,
      sortType: "Custom" as SortType,
      alg: sortRuleStatus
    },
    filter: new Filter(eFilter.Select, {
      textProps: {
        id: "ruleStatusFilterText",
        name: "isActive",
        className: "tbl--filter-select",
        onChange: e => filterOnChange(e, true),
        InputLabelProps: { shrink: filterVals.has("isActive") }
      },
      selectMenuProps: { MenuProps: { className: "bracket-Select" } },
      menuProps: {},
      selectData: activeStatuses,
      defaultSelect: true
    }),
    tableCellProps: { id: "ruleStatusHeader" },
    divProps: { id: "ruleStatus_div" },
    formatProp: {
      formatPropName: "isActive",
      format: (val: boolean) => <MddStatus isActive={val} />
    }
  }
];
